<template>
    <vue-dialog :visible.sync="dialogVisible" title="增加账号" size="tiny">
        <div class="add-form">
            <div class="form-group">
                <label class="form-label">资金初始量</label>
                <div class="form-input">
                    <input type="text" v-model="asset" maxlength="5" placeholder="上限1亿元" oninput="value=value.replace(/[^0-9]/g,'')">
                    <span class="unit">万元</span>
                </div>
            </div>
            <div class="form-group">
                <label class="form-label">备注</label>
                <div class="form-input">
                    <input type="text" v-model="remark" maxlength="20" placeholder="最多可输入20字">
                </div>
            </div>
        </div>
        <template slot="footer">
            <vue-button @click="commit" :type="'blue'" :size="'large'" v-stat="$stats.personalCenter.submitAccount">生成</vue-button>
        </template>
    </vue-dialog>
</template>
<script>
import axios from 'axios';
const DEFAULT_ASSET = 500;
export default {
    data () {
        return {
            remark: '',
            dialogVisible: false,
            asset: DEFAULT_ASSET
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        commit () {
            if (!this.asset) {
                this.$message({
                    message: '请输入资金初始量',
                    type: 'error',
                    showClose: true
                });
                return;
            }
            if (Number(this.asset) > 10e3) {
                this.$message({
                    message: '资金初始量上限为1亿元',
                    type: 'error',
                    showClose: true
                });
                return;
            }
            axios.post('/simu_account/apply', {
                asset: DEFAULT_ASSET * 10e3,
                remark: this.remark,
                transfer: (this.asset - DEFAULT_ASSET) * 10e3
            })
                .then(response => {
                    const body = response.data
                    if (body.status_code !== 0) {
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: body.status_msg,
                            duration: 2000,
                            type: 'warning',
                            showClose: true
                        });
                    }
                })
                .catch(error => {
                    this.$message({
                        message: error ? error.message : '网络异常',
                        duration: 0,
                        type: 'error',
                        showClose: true
                    });
                })
                .finally(() => {
                    this.dialogVisible = false;
                    this.$emit('update-list');
                });
        }
    },
    watch: {
        dialogVisible (val) {
            if (!val) {
                this.remark = ''
                this.asset = DEFAULT_ASSET
            }
            this.$emit('update:visible', val)
        },
        visible (val) {
            this.dialogVisible = val
        }
    }
}
</script>

<style lang="scss" scoped>
    .add-form {
        padding: 20px 30px;
        color: black;
        .form-group {
            padding: 10px 0;
            text-align: left;
            .form-label {
                min-width: 80px;
                display: inline-block;
            }
            .form-input {
                display: inline-block;
                input,select {
                    border-radius: 1px;
                    border: 1px solid #b1b1b1;
                    line-height: 20px;
                    padding-left: 5px;
                    width: 224px;
                    height: 30px;
                    border-radius: 4px;
                    border: 1px solid #d9d9d9;
                    box-sizing: border-box;
                }
                .unit {
                    position: absolute;
                    right: 8px;
                    line-height: 30px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/simuAccountApplication/add.vue